module.exports = __webpack_public_path__ + "038d18d3ac39e647a8bd309d17a4d470.png";